import { warnIfUsingNextAnalyticsModeForServiceFeature } from '../../app/engine.js';
import { smartSnippetAnalyticsClient } from '../../features/question-answering/question-answering-analytics-actions.js';
import { buildCoreSmartSnippetQuestionsList, } from '../core/smart-snippet-questions-list/headless-core-smart-snippet-questions-list.js';
import { buildSmartSnippetInteractiveInlineLinks, } from '../smart-snippet/headless-smart-snippet-interactive-inline-links.js';
import { buildSmartSnippetInteractiveQuestions } from './headless-smart-snippet-interactive-questions.js';
/**
 * Creates a `SmartSnippetQuestionsList` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `SmartSnippetQuestionsList` properties.
 * @returns A `SmartSnippetQuestionsList` controller instance.
 *
 * @group Controllers
 * @category SmartSnippetQuestionsList
 * */
export function buildSmartSnippetQuestionsList(engine, props) {
    warnIfUsingNextAnalyticsModeForServiceFeature(engine.state.configuration.analytics.analyticsMode);
    const smartSnippetQuestionList = buildCoreSmartSnippetQuestionsList(engine, smartSnippetAnalyticsClient);
    const interactiveInlineLinks = buildSmartSnippetInteractiveInlineLinks(engine, {
        options: { selectionDelay: props?.options?.selectionDelay },
    });
    const interactiveQuestions = buildSmartSnippetInteractiveQuestions(engine, {
        options: { selectionDelay: props?.options?.selectionDelay },
    });
    return {
        ...smartSnippetQuestionList,
        get state() {
            return smartSnippetQuestionList.state;
        },
        selectSource(identifier) {
            interactiveQuestions.selectSource(identifier);
        },
        beginDelayedSelectSource(identifier) {
            interactiveQuestions.beginDelayedSelectSource(identifier);
        },
        cancelPendingSelectSource(identifier) {
            interactiveQuestions.cancelPendingSelectSource(identifier);
        },
        selectInlineLink(identifier, link) {
            interactiveInlineLinks.selectInlineLink(link, identifier);
        },
        beginDelayedSelectInlineLink(identifier, link) {
            interactiveInlineLinks.beginDelayedSelectInlineLink(link, identifier);
        },
        cancelPendingSelectInlineLink(identifier, link) {
            interactiveInlineLinks.cancelPendingSelectInlineLink(link, identifier);
        },
    };
}
